import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useTranslation } from "react-i18next"

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  isPending: boolean
}

export function CustomerAIDisableDialog({ open, onClose, onConfirm, isPending }: Props) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent>
        <DialogHeader className="flex flex-col gap-6">
          <DialogTitle>{t("customers.profile.ai.disable.title")}</DialogTitle>
          <DialogDescription>{t("customers.profile.ai.disable.description")}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="pt-4 gap-2">
          <Button type="button" variant="outline" onClick={onClose} disabled={isPending}>
            {t("shared.cancel")}
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} disabled={isPending}>
            {t("customers.profile.ai.disable.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
